// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.invoice-subject .el-form-item__content {\n  line-height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
